
export const R = {
  color: {
    primary: '#0d9488',
    accent: '#f50057',
    accent_light: '#f73378',
    accent_dark: '#ab003c',

    

    app_bar: "#0f766e",
    // app_bar_detail: "#0f766e", // = actionbar
    app_bar_darker: "#115e59",

    paper: "#EEEEEE",
    background: "#FAFAFA",
    white:"white",

    option_selected: "#0d9488",
    subtitle_blue: "#005A9E"
    
  },


}

export const DOT = "/";
